module.exports = __webpack_public_path__ + "static/media/impact.7734008c.jpg";